import React from 'react';

import { PricingProvider } from 'contexts/pricing.context';
import PricingContent from './content';

const PricingLayout = () => {
  return (
    <PricingProvider>
      <PricingContent />
    </PricingProvider>
  );
};

export default PricingLayout;
